import get from 'lodash.get';

const defaultValue = Object.freeze([]);

const getExternalUpsellTypes = (rootState) =>
  get(rootState, 'user.partnerData.properties.externalUpsellTypes', defaultValue);

export default getExternalUpsellTypes;
